import { Component } from '@angular/core';

@Component({
    selector: 'singleview-link',
    template: `
	<label  (click) = "navigateToDetailPage()" style="cursor:pointer"> <u> {{value}} </u> </label>`,
    standalone: false
})

export class GridSingleviewLinkHomeGridComponent {

	public params: any;
	value: any;
	color;
	constructor() { }
	agInit(params: any): void {
		this.params = params;
		this.value = this.params.data.description;
		
		
	}

	navigateToDetailPage() {
		
		this.params.context.componentParent.redirectToDetailPage(this.params.data);

	}
}